// extracted by mini-css-extract-plugin
export default {"root":"InviteUserModal_root__PQsm+","container":"InviteUserModal_container__1kH-M"};